import { relAttrValAssocObj } from "data/globalData";
import { Box, List } from "@mui/material";
import { inputTypes, arrType } from "data/globalData";
import { getColDefaultValue } from "data/globalData";
import RenderInputField from "../RenderInputField/RenderInputField";

export const removeDropdownOptionsBasedonDependency = (column, data, options, allAttributes, selectOptObjName) => {
	if ((column?.input_type === inputTypes.SELECT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key) && options) {
		let list = [];
		console.log(column, allAttributes, options, "columnsd.........");

		let dependentCols = allAttributes?.filter((row) => column?.dependency?.[row.key] === true);

		if (dependentCols?.length) {
			options?.list?.forEach((attrVal) => {
				let push = true;
				dependentCols.forEach((col) => {
					// console.log("Checking column:", col.key, "Input Type:", col.input_type);
					// console.log("data[col.key]:", data[col.key]);
					if (data?.[col.key] && data?.[col.key] !== getColDefaultValue(col))
						if (column.key === "category") console.log(data?.[col.key], attrVal?.dependency?.[col.key], "hdkasdhkvf");

					if (col.input_type === inputTypes.SELECT.key) {
						// console.log("Inside SELECT condition!");

						if (attrVal?.dependency?.[col.key]?.includes(data?.[col.key])) {
						} else push = false;
					} else if (col.input_type === inputTypes.MULTIPLE_SELECT.key) {
						const dep = attrVal?.dependency?.[col.key]?.[0] ? attrVal?.dependency?.[col.key] : [];
						const arr1Len = [...data?.[col.key], ...dep].length;
						const arr2Len = [...new Set([...data?.[col.key], ...dep])].length;
						// console.log("Inside MULTIPLE_SELECT condition!", arr1Len, arr2Len);

						if (arr2Len < arr1Len) {
						} else push = false;
					} else push = false;
				});
				if (push) list.push(attrVal);
			});
		} else list = Array.isArray(options?.list) ? options?.list : [];
		return {
			type: arrType,
			list: list.map((val) => {
				if (typeof options?.getOptionLabel === "function") return options?.getOptionLabel(val);
				else return val;
			}),
		};
	} else return {};
};
const RenderAttributes = ({
	columns,
	setData,
	data,
	attrGrp,
	errObj,
	setErrorObj,
	allColumns,
	dependencyBasedOptFilterFun,
	selectOptObjName,
	width,
	longWidth,
}) => {
	return (
		<>
			{errObj &&
				columns?.map((column) => (
					<RenderAttribute
						key={column.key}
						column={column}
						data={data}
						setData={setData}
						errObj={errObj}
						setErrorObj={setErrorObj}
						allColumns={allColumns}
						dependencyBasedOptFilterFun={dependencyBasedOptFilterFun}
						selectOptObjName={selectOptObjName}
						width={width}
						longWidth={longWidth}
					/>
				))}
		</>
	);
};
export default RenderAttributes;

export const RenderAttribute = ({
	column,
	data,
	setData,
	attrGrp,
	errObj = {},
	setErrorObj,
	allColumns = [],
	dependencyBasedOptFilterFun,
	selectOptObjName,
	width = "30%",
	longWidth = "49%",
	disabled = false,
}) => {
	let options = {};
	if (column?.input_type === inputTypes.SELECT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key)
		options =
			typeof dependencyBasedOptFilterFun === "function"
				? dependencyBasedOptFilterFun(column, data, column[selectOptObjName], allColumns, selectOptObjName)
				: removeDropdownOptionsBasedonDependency(column, data, column[selectOptObjName], allColumns, selectOptObjName);

	return (
		<RenderInputField
			column={{ ...column, [selectOptObjName]: options }}
			data={data}
			setData={setData}
			selectOptObjName={selectOptObjName}
			width={width}
			longWidth={longWidth}
			disabled={disabled}
			// error={errObj?.[column.key] ? true : false}
			setError={setErrorObj}
			// dependencyColData={}
		/>
	);
};
//
